export default __webpack_public_path__ + "static/media/G0001.b93a4251.png";